// Types
export type { Author } from './types'

// Data & getters
export { getAuthorById, getDefaultAuthor } from './data'
